import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { CountriesApiService } from "./apiService.js";
import { countryFilterKey } from "./constants.js";
class CountriesService {
  _countriesApiService;
  constructor(httpService, apiUrl) {
    this._countriesApiService = new CountriesApiService(httpService, apiUrl);
  }
  get(requestPayload) {
    return this._countriesApiService.getCountries().pipe(
      map((response) => ({
        ...response,
        requestPayload,
        responsePayload: { items: response?.responsePayload, total: response?.responsePayload?.length }
      }))
    );
  }
}
class StatesService {
  _countriesApiService;
  constructor(httpService, apiUrl) {
    this._countriesApiService = new CountriesApiService(httpService, apiUrl);
  }
  get(requestPayload) {
    const countryCode = this.getStateCountryIsoCode(requestPayload.filter);
    return this._countriesApiService.getStates(countryCode).pipe(
      map((res) => ({
        ...res,
        requestPayload,
        responsePayload: { items: res?.responsePayload, total: res?.responsePayload?.length }
      }))
    );
  }
  getStateCountryIsoCode(filter) {
    const searchParams = new URLSearchParams(filter);
    return searchParams.get(countryFilterKey);
  }
}
export {
  CountriesService,
  StatesService
};
//# sourceMappingURL=service.js.map
